function base64UrlEncode (bytes) {
  let binary = '';
  bytes.forEach(byte => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function createCodeVerifier () {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);

  return base64UrlEncode(bytes);
}

/** Requires a secure context (https or localhost) for window.crypto.subtle. */
export async function createCodeChallenge (codeVerifier) {
  const digest = await window.crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(codeVerifier)
  );

  return base64UrlEncode(new Uint8Array(digest));
}
